import { render, staticRenderFns } from "./EditorSaveChangesPrompt.vue?vue&type=template&id=3cf08075"
import script from "./EditorSaveChangesPrompt.vue?vue&type=script&lang=js"
export * from "./EditorSaveChangesPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports